import { cx } from "@/lib/cx";

import styles from "./Wordmark.module.css";

export interface WordmarkProps {
  /** Glyph only (e.g. a collapsed sidebar); the name stays available to assistive technology. */
  glyphOnly?: boolean;
  className?: string | undefined;
}

/** The Orthos wordmark. The right-angle glyph nods to the name (orthogonal) and is decorative. */
export function Wordmark({ glyphOnly = false, className }: WordmarkProps) {
  return (
    <span className={cx(styles.wordmark, className)}>
      <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        className={styles.glyph}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      >
        <path d="M3 2v11h11" />
        <path d="M3 9h4v4" strokeWidth="1.5" />
      </svg>
      <span className={glyphOnly ? "sr-only" : undefined}>Orthos</span>
    </span>
  );
}
